(function () {
	angular
		.module('trackeye')
		.factory('Limitation', _LimitationFactory);

	_LimitationFactory.$inject = [];

	function _LimitationFactory() {

		function Limitation() {
			this.definition = undefined;
		}

		/**
		 * Filter events
		 * @param eventTypes
		 * @returns {*}
		 */
		Limitation.prototype.filterEvents = function (eventTypes) {
			var evt = this._get('events');

			if (!evt)
				return eventTypes;

			if (evt.only)
				eventTypes = evt.only;

			if (evt.exclude) {
				eventTypes = eventTypes.filter(function (eventType) {
					return (evt.exclude.indexOf(eventType) == -1);
				});
			}

			return eventTypes;
		};

		/**
		 * Filter report intervals
		 * @param intervals
		 * @returns {*}
		 */
		Limitation.prototype.filterReportInterval = function (intervals) {
			var report = this._get('configuration.report_interval');

			if (!report)
				return intervals;

			if (report.include) {
				intervals = intervals.filter(function (interval) {
					return (report.include.indexOf(interval) == -1);
				});
				intervals = intervals.concat(report.include);
			}

			return intervals;
		};

		/**
		 * Filter GSensor intervals
		 * @param intervals
		 * @returns {*}
		 */
		Limitation.prototype.filterGSensor = function (intervals) {
			var gsensor = this._get('configuration.gsensor_interval');

			if (!gsensor)
				return intervals;

			if (gsensor.include) {
				intervals = intervals.filter(function (interval) {
					return (gsensor.include.indexOf(interval) == -1);
				});
				intervals = intervals.concat(gsensor.include);
			}

			return intervals;
		};

		/**
		 * Assert if given configuration feature is disabled
		 *
		 * @param feat
		 * @returns {boolean}
		 */
		Limitation.prototype.isConfDisabled = function (feat) {
			var disabled = this._get('configuration.disabled');

			// If not defined, we'll assume that the configuration, is NOT disabled.
			if (!angular.isDefined(disabled))
				return false;

			return (disabled.indexOf(feat) >= 0);
		};

		Limitation.prototype.setDefinition = function (data) {
			if (data)
				this.definition = data;

			return this;
		};

		Limitation.prototype._has = function (key) {
			return !!(this.definition[key]);
		};

		/**
		 *
		 * @param {string} path
		 * @param {Object} [newPart]
		 * @returns {*}
		 * @private
		 */
		Limitation.prototype._get = function (path, newPart) {
			var part = newPart || this.definition,
				path_split = path.split("."),
				key = path_split.shift();

			if (!part)
				return undefined;

			if (path_split.length == 0)
				return part[key];

			if (part.hasOwnProperty(key))
				return this._get(path_split.join("."), part[key]);

			return undefined;
		};

		return Limitation;
	}
})();